import { get, post } from "../../data/api";
export async function getChoices() {
    return await get('deposit/choices')
}

export async function capture(rentalPublicId, fees) {
    return await post({ fees }, 'deposit/capture/' + rentalPublicId)
}

export async function getStripeDepositLogs(rentalPublicId) {
    return await get('deposit/stripe-logs/' + rentalPublicId)
}
